import { AfterViewInit, Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Entity} from '../../entity/entity';
import {EntityLine} from '../../entity/entity-line';
import {EntityLineHeader} from '../../entity/entity-line-header';
import {TagInformation} from '../../model/tag-information';
import {GuruEntity} from '../../model/guru-entity';
import {UnitRatingResponse} from '../../model/unit-rating-response';
import {Sku} from '../../model/sku';
import {SfrEntry} from '../../model/sfr-entry';
import {IecLeadTime} from '../../model/iec-lead-time';
import {Observable, Subject} from 'rxjs';
import {ConfigurationSaveInformation} from '../../model/configuration-save-information';
import {ProductModel} from '../product-model';
import {ConfigurationService} from '../configuration.service';

@Component({
    selector: 'app-vertical-floor-classic-product-model',
    templateUrl: './vertical-floor-classic-product-model.component.html',
    styleUrls: ['./vertical-floor-classic-product-model.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class VerticalFloorClassicProductModelComponent implements AfterViewInit, ProductModel {
  private readonly configurationService = inject(ConfigurationService);


  entity!: Entity;
  readonly entityLine = signal<EntityLine>(undefined!);
  entityLineHeader!: EntityLineHeader;
  readonly taggingDetails = signal<TagInformation[]>(undefined!);
  readonly isBusy = signal(false);
  readonly isLoaded = signal(false);
  readonly errorMessage = signal<string>(undefined!);
  readonly unitImagePath = signal<string>(undefined!);
  readonly invalidEntities = signal<string[]>(undefined!);
  readonly selectionEntities = signal<GuruEntity[]>(undefined!);
  readonly unitRatingResponse = signal<UnitRatingResponse>(undefined!);
  readonly messages = signal<string[]>(undefined!);
  readonly skus = signal<Sku[]>(undefined!);
  readonly sfrEntries = signal<SfrEntry[]>(undefined!);
  entityLeadTime!: IecLeadTime;
  readonly configurationLeadTime = signal<IecLeadTime>(undefined!);
  slowestLeadTime!: IecLeadTime;

  ngAfterViewInit(): void {
    this.isLoaded.set(true);
    this.isBusy.set(false);
  }

  initialize(): Observable<string> {
    const subject: Subject<string> = new Subject<string>();
    this.configurationService.isBusy.set(false);
    this.entityLine.set(new EntityLine());
    this.entityLine().quantityExtended = 1;
    this.taggingDetails.set([new TagInformation()]);
    setTimeout(() => subject.next('Initialization Complete'), 50);
    return subject;
  }

  getEngineKey(): string {
    return '';
  }

  quantityChanged(): void {
  }

  updateTaggingDetails(): void {
  }

  validateUnit(): void {
  }

  validateAndRateUnit(): void {
  }

  unitTypeChanged(): void {
  }

  systemTypeChanged(): void {
  }

  private updateUnitRating(): void {
  }

  inputUnitsChanged(): void {
  }

  getImagePrefix(): string {
    return '';
  }

  isOem(): boolean {
    return false;
  }

  getSaveInformation(): ConfigurationSaveInformation {
    return new ConfigurationSaveInformation();
  }

  saveUnit(): void {
    this.configurationService.isBusy.set(false);
  }

  applyMassUpdate(entities: GuruEntity[]): void {
  }

  sfrFlagChanged(): void {
  }

}
